import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'
import Constant from '../../Constant'
import './PushNotification.css'

class PushComposer extends React.Component {
  state = {
    currentStep: 0,
    
    activeLanguage: 'en',
    title_en: '',
    title_ar: '',
    message_en: '',
    message_ar: '',
    bannerImagePreview: '',
    bannerImagePath: '',
    isUploadingImage: false,
    
    clickAction: 'home',
    clickActionUrl: '',
    deepLinkType: '',
    deepLinkId: '',
    deepLinkTargets: [],
    isLoadingTargets: false,

    audienceType: 'all',
    segmentName: '',
    segments: [],
    targetUsers: [],
    userSearchKeyword: '',
    userSearchResults: [],
    userSearchLoading: false,
    platformIos: true,
    platformAndroid: true,
    
    scheduleType: 'immediate',
    scheduledDate: '',
    scheduledTime: '',
    timezoneValue: '',
    timezones: [],
    
    ttlHours: '',
    sendRate: '',
    
    isSubmitting: false,
    previewPlatform: 'android',
  }

  componentDidMount() {
    this.setState({
      timezones: this.getTimezoneList(),
      timezoneValue: this.guessTimezone()
    })
    this.loadSegments()
  }

  getTimezoneList = () => {
    let fallback = [
      'Asia/Kuwait', 'Asia/Riyadh', 'Asia/Dubai', 'Asia/Qatar', 'Asia/Bahrain',
      'Asia/Muscat', 'Africa/Cairo', 'Europe/London', 'Europe/Paris', 'Europe/Istanbul',
      'Asia/Karachi', 'Asia/Kolkata', 'Asia/Dhaka', 'Asia/Jakarta', 'Asia/Singapore',
      'Asia/Manila', 'Asia/Tokyo', 'Australia/Sydney', 'America/New_York', 'America/Chicago',
      'America/Denver', 'America/Los_Angeles', 'UTC'
    ]
    try {
      if (typeof Intl.supportedValuesOf === 'function') {
        return Intl.supportedValuesOf('timeZone')
      }
    } catch (e) {
      return fallback
    }
    return fallback
  }

  guessTimezone = () => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Kuwait'
    } catch (e) {
      return 'Asia/Kuwait'
    }
  }

  componentWillUnmount() {
    clearTimeout(this._searchDebounce)
  }

  loadSegments = () => {
    axios.get(Constant.getAPI() + '/push-campaigns/segments', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`
      }
    })
    .then(res => {
      if (res.data && res.data.success) {
        this.setState({ segments: res.data.data || [] })
      }
    })
    .catch(err => {
      if (err?.response?.status === 401) {
        Constant.getAuthLogout()
      } else {
        Swal.fire({
          title:
            err?.response?.data?.data?.details?.[0]?.message ||
            err?.response?.data?.message ||
            'Failed to load segments',
          icon: 'error',
          text: '',
          type: 'error',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
      }
    })
  }

  deepLinkSections = [
    { code: 'C', label: 'Cruise Category' },
    { code: 'Y', label: 'Cruise' },
    { code: 'T', label: 'Trip' },
    { code: 'E', label: 'Event' },
    { code: 'D', label: 'Destination' },
    { code: 'S', label: 'Store' },
    { code: 'CH', label: 'Chalet' },
    { code: 'EL', label: 'External Link' }
  ]

  deepLinkSources = {
    C: { url: '/cruise/list-cruise-masters', activeOnly: true, name: (itm) => itm.cruise_cat_en },
    Y: { url: '/cruise/list-cruise', name: (itm) => itm.cruise_name_en },
    T: { url: '/admin/trip', name: (itm) => itm.name_en },
    E: { url: '/event/list-events', activeOnly: true, name: (itm) => itm.event_name_en },
    D: { url: '/admin/list-destinations', activeOnly: true, name: (itm) => itm.destination_address_en },
    S: {
      url: '/store/list-stores',
      activeOnly: true,
      filter: (itm) => itm.shop_type === 'STORE' && (itm.shop_subscription_type === 'both' || itm.shop_subscription_type === 'store_order'),
      name: (itm) => itm.shop_name_en
    },
    CH: { url: '/chalet/list-chalet', activeOnly: true, name: (itm) => `${itm.name_en || ''} / ${itm.name_ar || ''}` }
  }

  loadDeepLinkTargets = (sectionCode) => {
    const source = this.deepLinkSources[sectionCode]
    if (!source) {
      this.setState({ deepLinkTargets: [], isLoadingTargets: false })
      return
    }

    this.setState({ deepLinkTargets: [], isLoadingTargets: true })

    axios.get(Constant.getAPI() + source.url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`
      }
    })
    .then(res => {
      let targets = []
      if (res.data && res.data.success) {
        targets = (res.data.data || [])
          .filter(itm => itm && (!source.activeOnly || itm.is_active) && (!source.filter || source.filter(itm)))
          .map(itm => ({ id: itm.id, name: source.name(itm) || itm.id }))
      }
      this.setState({ deepLinkTargets: targets, isLoadingTargets: false })
    })
    .catch(err => {
      this.setState({ deepLinkTargets: [], isLoadingTargets: false })
      if (err?.response?.status === 401) {
        Constant.getAuthLogout()
      } else {
        Swal.fire({
          title:
            err?.response?.data?.data?.details?.[0]?.message ||
            err?.response?.data?.message ||
            'Failed to load deep link targets',
          icon: 'error',
          text: '',
          type: 'error',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
      }
    })
  }

  getSelectedTarget = () => {
    return this.state.deepLinkTargets.find(t => String(t.id) === String(this.state.deepLinkId))
  }

  getSectionLabel = (code) => {
    const section = this.deepLinkSections.find(s => s.code === code)
    return section ? section.label : code
  }

  handleChange = (e) => {
    const { name, value, type, checked } = e.target

    if (name === 'deepLinkType') {
      this.setState({
        deepLinkType: value,
        deepLinkId: '',
        clickActionUrl: value === 'EL' ? this.state.clickActionUrl : ''
      })
      this.loadDeepLinkTargets(value)
      return
    }

    this.setState({
      [name]: type === 'checkbox' ? checked : value
    })
  }

  handleLanguageSwitch = (lang) => {
    this.setState({ activeLanguage: lang })
  }

  handlePlatformPreviewSwitch = (platform) => {
    this.setState({ previewPlatform: platform })
  }

  handleImageUpload = (e) => {
    const file = e.target.files[0]
    if (file) {
      this.setState({
        bannerImagePreview: URL.createObjectURL(file),
        bannerImagePath: '',
        isUploadingImage: true
      })

      const formData = new FormData()
      formData.append('image', file)

      axios.post(Constant.getAPI() + '/admin/upload-image', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`
        }
      })
      .then(res => {
        const imagePath = res?.data?.success ? res?.data?.data?.img_path : ''
        if (imagePath) {
          this.setState({ bannerImagePath: imagePath, isUploadingImage: false })
        } else {
          this.setState({ bannerImagePreview: '', bannerImagePath: '', isUploadingImage: false })
          Swal.fire({
            title: res?.data?.message || 'Failed to upload the banner image',
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .catch(err => {
        this.setState({ bannerImagePreview: '', bannerImagePath: '', isUploadingImage: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title:
              err?.response?.data?.data?.details?.[0]?.message ||
              err?.response?.data?.message ||
              'Failed to upload the banner image',
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
    }
  }

  removeImage = () => {
    this.setState({
      bannerImagePreview: '',
      bannerImagePath: '',
      isUploadingImage: false
    })
  }

  searchUsers = (keyword) => {
    this.setState({ userSearchKeyword: keyword })
    if (keyword.length < 2) {
      this.setState({ userSearchResults: [], userSearchLoading: false })
      return
    }
    
    clearTimeout(this._searchDebounce)
    this._searchDebounce = setTimeout(() => {
      this.setState({ userSearchLoading: true })
      axios.get(Constant.getAPI() + '/push-campaigns/users/search', {
        params: { keyword },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`
        }
      })
      .then(res => {
        if (res.data && res.data.success) {
          const users = (res.data.data || []).map(u => ({
            id: u.id,
            name: `${u.first_name || ''} ${u.last_name || ''}`.trim(),
            email: u.email || '',
            phone: u.phone || '',
            hasDeviceToken: u.has_device_token !== false
          }))
          this.setState({ userSearchResults: users, userSearchLoading: false })
        }
      })
      .catch(err => {
        this.setState({ userSearchResults: [], userSearchLoading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title:
              err?.response?.data?.data?.details?.[0]?.message ||
              err?.response?.data?.message ||
              'Failed to search users',
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
    }, 500)
  }

  addUser = (user) => {
    const { targetUsers } = this.state
    if (!targetUsers.find(u => u.id === user.id)) {
      this.setState({ targetUsers: [...targetUsers, user] })
    }
    this.setState({ userSearchKeyword: '', userSearchResults: [] })
  }

  removeUser = (userId) => {
    this.setState({
      targetUsers: this.state.targetUsers.filter(u => u.id !== userId)
    })
  }

  getStepTitle = (step) => {
    const titles = ['Content', 'Click Action', 'Audience', 'Schedule', 'Delivery', 'Review']
    return titles[step]
  }

  handleStepClick = (step) => {
    if (step <= this.state.currentStep) {
      this.setState({ currentStep: step })
    }
  }

  validateStep = (step) => {
    const { title_en, title_ar, message_en, message_ar, clickAction, clickActionUrl, deepLinkType, deepLinkId, audienceType, segmentName, targetUsers, scheduleType, scheduledDate, scheduledTime } = this.state

    switch (step) {
      case 0: {
        const hasEnglish = title_en.trim() && message_en.trim()
        const hasArabic = title_ar.trim() && message_ar.trim()
        if (!hasEnglish && !hasArabic) {
          Swal.fire('Error', 'Please provide a title and message in at least one language', 'error')
          return false
        }
        if (this.state.isUploadingImage) {
          Swal.fire('Please wait', 'The banner image is still uploading', 'info')
          return false
        }
        break
      }
      case 1:
        if (clickAction === 'deeplink') {
          if (!deepLinkType) {
            Swal.fire('Error', 'Please select a deep link section', 'error')
            return false
          }
          if (deepLinkType === 'EL') {
            if (!clickActionUrl.trim()) {
              Swal.fire('Error', 'Please provide a web URL', 'error')
              return false
            }
            if (!/^https?:\/\//i.test(clickActionUrl.trim())) {
              Swal.fire('Error', 'The URL must start with http:// or https://', 'error')
              return false
            }
          } else if (!deepLinkId) {
            Swal.fire('Error', 'Please select the item to open', 'error')
            return false
          }
        }
        break
      case 2:
        if (!this.state.platformIos && !this.state.platformAndroid) {
          Swal.fire('Error', 'Select at least one platform', 'error')
          return false
        }
        if (audienceType === 'segment' && !segmentName) {
          Swal.fire('Error', 'Please select a segment', 'error')
          return false
        }
        if (audienceType === 'users' && targetUsers.length === 0) {
          Swal.fire('Error', 'Please select at least one user', 'error')
          return false
        }
        break
      case 3:
        if (scheduleType === 'scheduled' && (!scheduledDate || !scheduledTime)) {
          Swal.fire('Error', 'Please provide a valid schedule date and time', 'error')
          return false
        }
        break
      default:
        return true
    }
    return true
  }

  nextStep = () => {
    if (this.validateStep(this.state.currentStep)) {
      this.setState({ currentStep: this.state.currentStep + 1 })
    }
  }

  prevStep = () => {
    this.setState({ currentStep: this.state.currentStep - 1 })
  }

  handleSubmit = () => {
    Swal.fire({
      title: 'Are you sure you want to send this notification?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Send',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.setState({ isSubmitting: true })
        
        const platforms = []
        if (this.state.platformIos) platforms.push('ios')
        if (this.state.platformAndroid) platforms.push('android')

        let scheduledAt = null
        if (this.state.scheduleType === 'scheduled' && this.state.scheduledDate && this.state.scheduledTime) {
          scheduledAt = `${this.state.scheduledDate}T${this.state.scheduledTime}`
        }

        const isExternalLink = this.state.clickAction === 'deeplink' && this.state.deepLinkType === 'EL'
        const isDeepLink = this.state.clickAction === 'deeplink' && !isExternalLink
        const clickActionValue = isExternalLink ? 'url' : this.state.clickAction

        const payload = {
          title_en: this.state.title_en,
          title_ar: this.state.title_ar || '',
          message_en: this.state.message_en,
          message_ar: this.state.message_ar || '',
          banner_image: this.state.bannerImagePath || '',
          click_action: clickActionValue,
          click_action_value: isExternalLink ? this.state.clickActionUrl.trim() : '',
          deep_link_type: isDeepLink ? this.state.deepLinkType || '' : '',
          deep_link_id: isDeepLink ? String(this.state.deepLinkId || '') : '',
          audience_type: this.state.audienceType,
          segment_name: this.state.segmentName || '',
          target_user_ids: this.state.targetUsers.map(u => u.id),
          platforms: platforms.join(','),
          schedule_type: this.state.scheduleType,
          scheduled_at: scheduledAt || null,
          timezone_type: this.state.scheduleType === 'scheduled' ? 'custom' : 'device',
          timezone_value: this.state.timezoneValue || '',
          ttl_hours: this.state.ttlHours ? parseInt(this.state.ttlHours) : null,
          send_rate: this.state.sendRate || ''
        }
        
        axios.post(Constant.getAPI() + '/push-campaigns/send', payload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`
          }
        })
        .then((res) => {
          this.setState({ isSubmitting: false })
          const status = res?.data?.data?.status
          const msg = status === 'scheduled' ? 'Notification scheduled successfully!' : 'Notification sent successfully!'
          Swal.fire('Success', msg, 'success').then(() => {
            window.location.href = '#/push-history'
          })
        })
        .catch(err => {
          this.setState({ isSubmitting: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title:
                err?.response?.data?.data?.details?.[0]?.message ||
                err?.response?.data?.message ||
                'Failed to send notification',
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
      }
    })
  }

  renderStepIndicator = () => {
    const steps = [0, 1, 2, 3, 4, 5]
    return (
      <div className="push-stepper">
        <div className="push-step-connector">
          <div className="push-step-connector-fill" style={{ width: `${(this.state.currentStep / 5) * 100}%` }}></div>
        </div>
        {steps.map(step => (
          <div key={step} className={`push-step ${this.state.currentStep === step ? 'active' : ''} ${this.state.currentStep > step ? 'completed' : ''}`} onClick={() => this.handleStepClick(step)} style={{ cursor: this.state.currentStep > step ? 'pointer' : 'default' }}>
            <div className="push-step-circle">
              {this.state.currentStep > step ? '✓' : step + 1}
            </div>
            <div className="push-step-label">{this.getStepTitle(step)}</div>
          </div>
        ))}
      </div>
    )
  }

  renderStep0_Content = () => {
    const { activeLanguage, title_en, title_ar, message_en, message_ar, bannerImagePreview, isUploadingImage, previewPlatform } = this.state
    const isEn = activeLanguage === 'en'
    
    return (
      <div className="row">
        <div className="col-sm-8">
          <div className="push-form-section">
            <div className="lang-tabs">
              <div className={`lang-tab ${isEn ? 'active' : ''}`} onClick={() => this.handleLanguageSwitch('en')}>English</div>
              <div className={`lang-tab ${!isEn ? 'active' : ''}`} onClick={() => this.handleLanguageSwitch('ar')}>Arabic</div>
            </div>
            
            <div className="form-group">
              <label className="push-form-label">Title {isEn ? '(EN)' : '(AR)'} *</label>
              <input type="text" className="form-control" name={isEn ? 'title_en' : 'title_ar'} value={isEn ? title_en : title_ar} onChange={this.handleChange} placeholder="Notification title" maxLength={100} />
              <div className="char-counter">{isEn ? title_en.length : title_ar.length}/100</div>
            </div>
            
            <div className="form-group">
              <label className="push-form-label">Message {isEn ? '(EN)' : '(AR)'} *</label>
              <textarea className="form-control" name={isEn ? 'message_en' : 'message_ar'} value={isEn ? message_en : message_ar} onChange={this.handleChange} placeholder="Notification body" rows={4} maxLength={500} />
              <div className="char-counter">{isEn ? message_en.length : message_ar.length}/500</div>
            </div>
            
            <div className="form-group">
              <label className="push-form-label">Banner Image (Optional)</label>
              {!bannerImagePreview ? (
                <div className="image-upload-zone" onClick={() => this.image_input && this.image_input.click()}>
                  <i className="icofont icofont-upload-alt f-24 mb-2 d-block"></i>
                  <span>Click to upload image</span>
                  <input type="file" id="imgUpload" hidden accept="image/*" onChange={this.handleImageUpload} ref={(ref) => (this.image_input = ref)} />
                </div>
              ) : (
                <div className="text-center">
                  <img src={bannerImagePreview} alt="Banner Preview" className="image-preview" />
                  {isUploadingImage && (
                    <div className="image-uploading-text">
                      <i className="icofont icofont-spinner-alt-2 icofont-spin"></i> Uploading...
                    </div>
                  )}
                  <div className="remove-img-btn" onClick={this.removeImage}>
                    <i className="icofont icofont-trash"></i> Remove Image
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        
        <div className="col-sm-4">
          <div className="platform-toggle">
            <button
              type="button"
              className={`platform-toggle-btn ${previewPlatform === 'ios' ? 'active' : ''}`}
              onClick={() => this.handlePlatformPreviewSwitch('ios')}
            >
              iOS
            </button>
            <button
              type="button"
              className={`platform-toggle-btn ${previewPlatform === 'android' ? 'active' : ''}`}
              onClick={() => this.handlePlatformPreviewSwitch('android')}
            >
              Android
            </button>
          </div>
          <div className="phone-preview-container">
            <div className={`phone-mockup phone-${previewPlatform}`}>
              <div className="phone-statusbar">
                <span>{moment().format('H:mm')}</span>
                <span className="phone-statusbar-icons">
                  <span className="sb-signal"><i /><i /><i /><i /></span>
                  <span className="sb-wifi"></span>
                  <span className="sb-battery"></span>
                </span>
              </div>

              <div className="phone-lock">
                <div className="phone-lock-time">{moment().format('H:mm')}</div>
                <div className="phone-lock-date">{moment().format('dddd, D MMMM')}</div>
              </div>

              <div className={`notification-card-preview card-${previewPlatform}`}>
                <div className="preview-header">
                  <div className="preview-app-icon">W</div>
                  <span className="preview-app-name">{previewPlatform === 'ios' ? 'WAVES APP' : 'Waves App'}</span>
                  <span className="preview-time">now</span>
                </div>
                <div
                  className="preview-title"
                  dir={isEn ? 'ltr' : 'rtl'}
                >
                  {isEn ? title_en || 'Title' : title_ar || 'العنوان'}
                </div>
                <div
                  className="preview-message"
                  dir={isEn ? 'ltr' : 'rtl'}
                >
                  {isEn ? message_en || 'Your message goes here' : message_ar || 'رسالتك هنا'}
                </div>
                {bannerImagePreview && <img src={bannerImagePreview} className="preview-image" alt="Preview" />}
              </div>

              <div className="phone-footer"></div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderStep1_ClickAction = () => {
    const { clickAction, clickActionUrl, deepLinkType, deepLinkId, deepLinkTargets, isLoadingTargets } = this.state
    return (
      <div className="push-form-section">
        <h5 className="mb-4">What should happen when the user clicks the notification?</h5>
        
        <div className="push-radio-group">
          <div className={`push-radio-option ${clickAction === 'home' ? 'selected' : ''}`} onClick={() => this.setState({ clickAction: 'home' })}>
            <div className="push-radio-title">Open App Home</div>
            <div className="push-radio-desc">Just opens the app to the main screen</div>
          </div>
          <div className={`push-radio-option ${clickAction === 'deeplink' ? 'selected' : ''}`} onClick={() => this.setState({ clickAction: 'deeplink' })}>
            <div className="push-radio-title">Deep Link</div>
            <div className="push-radio-desc">Open a screen in the app, or an external web page</div>
          </div>
        </div>

        {clickAction === 'deeplink' && (
          <div className="row mt-4">
            <div className="col-sm-6">
              <div className="form-group">
                <label className="push-form-label">Section *</label>
                <select className="form-control" name="deepLinkType" value={deepLinkType} onChange={this.handleChange}>
                  <option value="">Select Section...</option>
                  {this.deepLinkSections.map(section => (
                    <option key={section.code} value={section.code}>{section.label}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-sm-6">
              {deepLinkType === 'EL' ? (
                <div className="form-group">
                  <label className="push-form-label">External Link *</label>
                  <input type="text" className="form-control" name="clickActionUrl" value={clickActionUrl} onChange={this.handleChange} placeholder="https://..." />
                  <small className="text-muted">Opens inside the app's web view.</small>
                </div>
              ) : (
                <div className="form-group">
                  <label className="push-form-label">Item *</label>
                  <select className="form-control" name="deepLinkId" value={deepLinkId} onChange={this.handleChange} disabled={!deepLinkType || isLoadingTargets}>
                    <option value="">
                      {!deepLinkType ? 'Select a section first...' : isLoadingTargets ? 'Loading...' : 'Select Item...'}
                    </option>
                    {deepLinkTargets.map(target => (
                      <option key={target.id} value={target.id}>{target.name}</option>
                    ))}
                  </select>
                  {deepLinkType && !isLoadingTargets && deepLinkTargets.length === 0 && (
                    <small className="text-muted">No active items found in this section.</small>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }

  renderStep2_Audience = () => {
    const { audienceType, segmentName, segments, targetUsers, userSearchKeyword, userSearchResults, userSearchLoading, platformIos, platformAndroid } = this.state
    return (
      <div className="push-form-section">
        <h5 className="mb-4">Who should receive this notification?</h5>
        
        <div className="row mb-4">
          <div className="col-sm-6">
            <label className="push-form-label">Target Platforms</label>
            <div className="d-flex">
              <label className="platform-checkbox mr-4">
                <input type="checkbox" name="platformIos" checked={platformIos} onChange={this.handleChange} /> iOS
              </label>
              <label className="platform-checkbox">
                <input type="checkbox" name="platformAndroid" checked={platformAndroid} onChange={this.handleChange} /> Android
              </label>
            </div>
          </div>
        </div>

        <div className="push-radio-group">
          <div className={`push-radio-option ${audienceType === 'all' ? 'selected' : ''}`} onClick={() => this.setState({ audienceType: 'all' })}>
            <div className="push-radio-title">All Users</div>
            <div className="push-radio-desc">Send to everyone who opted in</div>
          </div>
          <div className={`push-radio-option ${audienceType === 'segment' ? 'selected' : ''}`} onClick={() => this.setState({ audienceType: 'segment' })}>
            <div className="push-radio-title">Target Segment</div>
            <div className="push-radio-desc">Send to a specific user segment</div>
          </div>
          <div className={`push-radio-option ${audienceType === 'users' ? 'selected' : ''}`} onClick={() => this.setState({ audienceType: 'users' })}>
            <div className="push-radio-title">Specific Users</div>
            <div className="push-radio-desc">Send to selected individual users</div>
          </div>
        </div>
        
        {audienceType === 'segment' && (
          <div className="form-group mt-4">
            <label className="push-form-label">Select Segment *</label>
            <select className="form-control" name="segmentName" value={segmentName} onChange={this.handleChange}>
              <option value="">Select a segment...</option>
              {segments.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          </div>
        )}

        {audienceType === 'users' && (
          <div className="mt-4">
            <label className="push-form-label">Search Users</label>
            <input type="text" className="form-control mb-3" placeholder="Search by name or email..." value={userSearchKeyword} onChange={(e) => this.searchUsers(e.target.value)} />
            
            {userSearchLoading && (
              <div className="text-muted mb-3">
                <i className="icofont icofont-spinner-alt-2 icofont-spin"></i> Searching users...
              </div>
            )}

            {!userSearchLoading && userSearchResults.length > 0 && (
              <div className="list-group mb-3">
                {userSearchResults.map(user => (
                  <div key={user.id} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                    <div>
                      <strong>{user.name}</strong> <small className="text-muted">({user.email})</small>
                      {!user.hasDeviceToken && (
                        <span className="review-badge" style={{ background: '#f8d7da', color: '#721c24', marginLeft: 8 }}>
                          No device registered
                        </span>
                      )}
                    </div>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => this.addUser(user)}
                      disabled={!user.hasDeviceToken}
                    >
                      Add
                    </button>
                  </div>
                ))}
              </div>
            )}

            {!userSearchLoading && userSearchKeyword.length > 1 && userSearchResults.length === 0 && (
              <div className="text-muted mb-3">No reachable users found for this search.</div>
            )}
            
            {targetUsers.length > 0 && (
              <div>
                <label className="push-form-label mt-3">Selected Users ({targetUsers.length})</label>
                <div className="list-group">
                  {targetUsers.map(user => (
                    <div key={user.id} className="list-group-item d-flex justify-content-between align-items-center bg-light">
                      <span>{user.name}</span>
                      <button className="btn btn-sm btn-outline-danger" onClick={() => this.removeUser(user.id)}>Remove</button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }

  renderStep3_Schedule = () => {
    const { scheduleType, scheduledDate, scheduledTime, timezoneValue, timezones } = this.state
    return (
      <div className="push-form-section">
        <h5 className="mb-4">When should this notification be sent?</h5>
        
        <div className="push-radio-group">
          <div className={`push-radio-option ${scheduleType === 'immediate' ? 'selected' : ''}`} onClick={() => this.setState({ scheduleType: 'immediate' })}>
            <div className="push-radio-title">Send Immediately</div>
            <div className="push-radio-desc">Process and send right now</div>
          </div>
          <div className={`push-radio-option ${scheduleType === 'scheduled' ? 'selected' : ''}`} onClick={() => this.setState({ scheduleType: 'scheduled' })}>
            <div className="push-radio-title">Schedule for Later</div>
            <div className="push-radio-desc">Set a specific date and time</div>
          </div>
        </div>

        {scheduleType === 'scheduled' && (
          <div className="row mt-4">
            <div className="col-sm-4">
              <div className="form-group">
                <label className="push-form-label">Date *</label>
                <input type="date" className="form-control" name="scheduledDate" value={scheduledDate} onChange={this.handleChange} min={moment().format('YYYY-MM-DD')} />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label className="push-form-label">Time *</label>
                <input type="time" className="form-control" name="scheduledTime" value={scheduledTime} onChange={this.handleChange} />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label className="push-form-label">Timezone</label>
                <select className="form-control" name="timezoneValue" value={timezoneValue} onChange={this.handleChange}>
                  {timezones.map(tz => <option key={tz} value={tz}>{tz}</option>)}
                </select>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  renderStep4_Delivery = () => {
    const { ttlHours, sendRate } = this.state
    return (
      <div className="push-form-section">
        <h5 className="mb-4">Advanced Delivery Controls (Optional)</h5>

        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label className="push-form-label">Time to Live (TTL) in Hours</label>
              <input type="number" className="form-control" name="ttlHours" value={ttlHours} onChange={this.handleChange} placeholder="e.g. 24" />
              <small className="text-muted">How long device will keep trying to receive it if offline.</small>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label className="push-form-label">Send Rate Throttling</label>
              <select className="form-control" name="sendRate" value={sendRate} onChange={this.handleChange}>
                <option value="">No throttling (Fastest)</option>
                <option value="100">100 / second</option>
                <option value="500">500 / second</option>
                <option value="1000">1000 / second</option>
              </select>
              <small className="text-muted">Slow down delivery to protect your servers from traffic spikes.</small>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderStep5_Review = () => {
    const {
      title_en, title_ar, message_en, message_ar, bannerImagePreview,
      audienceType, segmentName, segments, targetUsers,
      scheduleType, scheduledDate, scheduledTime, timezoneValue,
      clickAction, clickActionUrl, deepLinkType, deepLinkId,
      platformIos, platformAndroid,
      ttlHours, sendRate
    } = this.state

    const segmentLabel = segments.find(s => s.id === segmentName)
    const selectedTarget = this.getSelectedTarget()
    const deepLinkLabel = `${this.getSectionLabel(deepLinkType)}${selectedTarget ? ' / ' + selectedTarget.name : deepLinkId ? ' / ' + deepLinkId : ''}`
    const isExternalLink = clickAction === 'deeplink' && deepLinkType === 'EL'

    return (
      <div className="push-form-section">
        <h5 className="mb-4">Review Campaign</h5>
        
        <div className="review-section">
          <h6 className="review-section-title">Content</h6>
          {title_en && (
            <div className="review-row">
              <div className="review-label">Title (EN)</div>
              <div className="review-value">{title_en}</div>
            </div>
          )}
          {title_ar && (
            <div className="review-row">
              <div className="review-label">Title (AR)</div>
              <div className="review-value" style={{ direction: 'rtl' }}>{title_ar}</div>
            </div>
          )}
          {message_en && (
            <div className="review-row">
              <div className="review-label">Message (EN)</div>
              <div className="review-value">{message_en}</div>
            </div>
          )}
          {message_ar && (
            <div className="review-row">
              <div className="review-label">Message (AR)</div>
              <div className="review-value" style={{ direction: 'rtl' }}>{message_ar}</div>
            </div>
          )}
          {bannerImagePreview && (
            <div className="review-row">
              <div className="review-label">Banner Image</div>
              <div className="review-value">
                <img src={bannerImagePreview} alt="Banner" style={{ maxWidth: 200, borderRadius: 8 }} />
              </div>
            </div>
          )}
        </div>

        <div className="review-section">
          <h6 className="review-section-title">Click Action</h6>
          <div className="review-row">
            <div className="review-label">Action</div>
            <div className="review-value text-capitalize">
              {clickAction === 'home' && 'Open App Home'}
              {isExternalLink && `External Link: ${clickActionUrl}`}
              {clickAction === 'deeplink' && !isExternalLink && `Deep Link: ${deepLinkLabel}`}
            </div>
          </div>
        </div>

        <div className="review-section">
          <h6 className="review-section-title">Audience & Platforms</h6>
          <div className="review-row">
            <div className="review-label">Platforms</div>
            <div className="review-value">
              {platformIos && <span className="review-badge badge-ios">iOS</span>}
              {platformAndroid && <span className="review-badge badge-android">Android</span>}
            </div>
          </div>
          <div className="review-row">
            <div className="review-label">Audience</div>
            <div className="review-value">
              {audienceType === 'all' && <span className="review-badge" style={{ background: '#e3f2fd', color: '#1565c0' }}>All Subscribers</span>}
              {audienceType === 'segment' && <span className="review-badge" style={{ background: '#fff3e0', color: '#e65100' }}>Segment: {segmentLabel ? segmentLabel.name : segmentName}</span>}
              {audienceType === 'users' && <span className="review-badge" style={{ background: '#f3e5f5', color: '#7b1fa2' }}>{targetUsers.length} Selected Users</span>}
            </div>
          </div>
        </div>

        <div className="review-section">
          <h6 className="review-section-title">Schedule</h6>
          <div className="review-row">
            <div className="review-label">When</div>
            <div className="review-value">
              {scheduleType === 'immediate'
                ? <span className="review-badge" style={{ background: '#e8f5e9', color: '#2e7d32' }}>Send Immediately</span>
                : <span>{scheduledDate} {scheduledTime} ({timezoneValue})</span>
              }
            </div>
          </div>
        </div>

        {(ttlHours || sendRate) && (
          <div className="review-section">
            <h6 className="review-section-title">Delivery Controls</h6>
            {ttlHours && (
              <div className="review-row">
                <div className="review-label">TTL</div>
                <div className="review-value">{ttlHours} hours</div>
              </div>
            )}
            {sendRate && (
              <div className="review-row">
                <div className="review-label">Send Rate</div>
                <div className="review-value">{sendRate} / second</div>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }

  render() {
    const { currentStep, isSubmitting } = this.state
    
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Push Notification Composer</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/push-history">Push Campaigns</Link>
                      </li>
                      <li className="breadcrumb-item active">Push Composer</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  {this.renderStepIndicator()}
                  <div className="card card-border-default">
                    <div className="card-block">
                      {currentStep === 0 && this.renderStep0_Content()}
                      {currentStep === 1 && this.renderStep1_ClickAction()}
                      {currentStep === 2 && this.renderStep2_Audience()}
                      {currentStep === 3 && this.renderStep3_Schedule()}
                      {currentStep === 4 && this.renderStep4_Delivery()}
                      {currentStep === 5 && this.renderStep5_Review()}

                      <div className="push-btn-group">
                        <button
                          className="btn btn-grd-disabled"
                          onClick={this.prevStep}
                          disabled={currentStep === 0 || isSubmitting}
                        >
                          Back
                        </button>

                        {currentStep < 5 ? (
                          <button className="btn hor-grd btn-grd-inverse" onClick={this.nextStep}>
                            Next Step
                          </button>
                        ) : (
                          <button
                            className="btn hor-grd btn-grd-inverse"
                            onClick={this.handleSubmit}
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Sending...' : 'Confirm & Send'}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PushComposer
